import Attribute from "./Attribute";
import EntityType from "./EntityType";

class CalculatedAttribute extends Attribute {
    constructor(name, def) {
        super(name, def);
        this.type = 'calculated';
        this.attributeType = def.type.type;
        this.subtype = this.attributeType === 'ref' ? def.type.reftype : def.type.type;
        this.definition = def.type.definition;
        this.input = 'readonly';
    }


    fromJson(data) {
        if (data == null || this.attributeType !== 'ref' || typeof data !== 'object' || !this.definition) {
            return data;
        }

        const et = new EntityType(this.definition);
        if (!Array.isArray(data)) {
            return et.createEntity(data);
        }

        return data.map(e => et.createEntity(e));
    }
}

export default CalculatedAttribute;